module.exports = __webpack_public_path__ + "static/media/UD.3b2fac1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/UD.mp4
// module id = yoKn
// module chunks = 0